import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const LoginSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Try to get tokens from query parameters first
    let access = searchParams.get('access');
    let refresh = searchParams.get('refresh');

    // If not found in query params, try hash fragment
    if (!access || !refresh) {
      const hash = window.location.hash.substring(1);
      const hashParams = new URLSearchParams(hash);
      access = access || hashParams.get('access');
      refresh = refresh || hashParams.get('refresh');
    }

    if (access && refresh) {
      localStorage.setItem('authToken', access);
      localStorage.setItem('refreshToken', refresh);
      navigate('/app/dashboard');
    } else {
      console.error('No tokens found in URL');
      navigate('/app/login');
    }
  }, [navigate, searchParams]);

  return <div>Logging you in...</div>;
};

export default LoginSuccess; 